import { SearchBlogInterface } from 'constants/interfaces';
import * as Yup from 'yup';

type TranslateFunction = (key: string, params?: Record<string, string>) => string;

export const searchBlogInitialValues: SearchBlogInterface = {
	keyword: '',
	categoryId: '',
};

export const SearchBlogSchema = (translate: TranslateFunction) =>
	Yup.object()
		.shape({
			keyword: Yup.string().trim(),
			categoryId: Yup.string(),
		})
		.test('at-least-one', function (value) {
			const { keyword, categoryId } = value;
			if (!!keyword || !!categoryId) {
				return true;
			} else {
				return this.createError({
					path: 'keyword',
					message: translate('Validation.atLeastOne'),
				});
			}
		});
